<template>
  <div class="patient-form-container" :class="modalTheme">
    <!-- Add the load button at the top -->
    <!-- <div class="form-actions-top">
      <button :disabled="!patientStore.currentPatient.lastName" type="button" class="btn btn-info" @click="loadFromPatientStore">Load Current Patient from Store</button>
      <button type="button" class="btn btn-secondary" @click="loadFromProps">Load from Props</button>
      <button type="button" class="btn btn-secondary" @click="loadSampleData">Load Sample Data</button>
      <span v-if="patientStore.currentPatient.lastName" class="current-patient-info"> Current: {{ patientStore.currentPatient.firstName }} {{ patientStore.currentPatient.lastName }} </span>
      <span v-else class="no-patient-info"> No current patient selected </span>
    </div> -->

    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
      <div class="form-section full-width" :class="userStore.borderClass">
        <h3 style="text-align: left">Guarantor Information</h3>

        <b-form-group label="Relation To Guarantor:" label-for="guarantorRelation" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-select
            id="guarantorRelation"
            :class="modalTheme"
            v-model="form.guarantorRelation"
            size="sm"
            :options="[
              { value: 0, text: 'Select relationship' },
              { value: 1, text: 'Self' },
              { value: 2, text: 'Spouse' },
              { value: 3, text: 'Parent' },
              { value: 4, text: 'Child' },
              { value: 5, text: 'Sibling' },
              { value: 6, text: 'Grandparent' },
              { value: 7, text: 'Grandchild' },
              { value: 8, text: 'Other Relative' },
              { value: 9, text: 'Guardian' },
              { value: 10, text: 'Other' },
            ]"
          />
        </b-form-group>

        <hr />

        <b-row class="mb-2">
          <b-col cols="3"></b-col>
          <b-col cols="9">
            <b-button variant="danger" size="sm" @click="selectGuarantor" class="me-2">Select</b-button>
            <b-button variant="danger" size="sm" @click="editGuarantor">Edit</b-button>
          </b-col>
        </b-row>

        <b-form-group label="Name:" label-for="guarantorName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="guarantorName" :class="modalTheme" v-model="form.guarantorName" size="sm" placeholder="Enter Name" />
        </b-form-group>

        <b-form-group label="SSN:" label-for="guarantorSSN" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="guarantorSSN" :class="modalTheme" v-model="form.guarantorSSN" size="sm" placeholder="Enter SSN" />
        </b-form-group>

        <b-form-group label="Date of Birth:" label-for="guarantorDateOfBirth" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="guarantorDateOfBirth" :class="modalTheme" v-model="form.guarantorDateOfBirth" type="date" size="sm" />
        </b-form-group>

        <b-form-group label="Sex:" label-for="guarantorSex" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-select
            id="guarantorSex"
            :class="modalTheme"
            v-model="form.guarantorSex"
            size="sm"
            :options="[
              { value: 0, text: 'Select sex' },
              { value: 1, text: 'Male' },
              { value: 2, text: 'Female' },
              { value: 3, text: 'Other' },
            ]"
          />
        </b-form-group>

        <b-form-group label="Home Address:" label-for="guarantorHomeAddress" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="guarantorHomeAddress" :class="modalTheme" v-model="form.guarantorHomeAddress" size="sm" placeholder="Enter home address" />
        </b-form-group>

        <b-form-group label="Work Address:" label-for="guarantorWorkAddress" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="guarantorWorkAddress" :class="modalTheme" v-model="form.guarantorWorkAddress" size="sm" placeholder="Enter work address" />
        </b-form-group>

        <b-form-group label="Home Phone:" label-for="guarantorHomePhone" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="guarantorHomePhone" :class="modalTheme" v-model="form.guarantorHomePhone" type="tel" size="sm" v-mask="'(###) ###-####'" placeholder="Enter home phone" />
        </b-form-group>

        <b-form-group label="Work Phone:" label-for="guarantorWorkPhone" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="guarantorWorkPhone" :class="modalTheme" v-model="form.guarantorWorkPhone" type="tel" size="sm" v-mask="'(###) ###-####'" placeholder="Enter work phone" />
        </b-form-group>

        <b-form-group label="Email Address:" label-for="guarantorEmailAdress" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="guarantorEmailAdress" :class="modalTheme" v-model="form.guarantorEmailAdress" type="email" size="sm" placeholder="Enter email address" />
        </b-form-group>
      </div>
      <pre style="color: cyan">{{ form }}</pre>
      <div class="form-actions">
        <b-button type="reset" variant="secondary">Reset</b-button>
        <b-button type="submit" variant="primary">Save Patient</b-button>
      </div>
    </b-form>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import moment from "moment";

// * STORE
import { usePatientStore } from "@/stores/patientStore";
import { searchForPatient } from "@/api/patientApi";
const patientStore = usePatientStore();

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

const modalTheme = computed(() => userStore.bModalTheme);

// Emits
const emit = defineEmits(["save-patient", "reset-form"]);

// & PROPS
const props = defineProps({
  testPatient: {
    Type: Object,
    Default: () => {},
  },
});

// Create form factory function
function createForm() {
  return {
    guarantorRelation: 0,
    guarantorName: "",
    guarantorSSN: "",
    guarantorDateOfBirth: "",
    guarantorSex: 0,
    guarantorHomeAddress: "",
    guarantorHomePhone: "",
    guarantorWorkAddress: "",
    guarantorWorkPhone: "",
    guarantorEmailAdress: "",
  };
}

// Form state
const form = ref(createForm());
const AreIdsShown = ref(true);

// Form validation
const isFormValid = () => {
  if (!form.value.firstName.trim()) {
    alert("First name is required");
    return false;
  }
  if (!form.value.lastName.trim()) {
    alert("Last name is required");
    return false;
  }
  if (!form.value.patientID.trim()) {
    alert("Patient ID is required");
    return false;
  }
  return true;
};

// Form handlers
function onSubmit() {
  if (!isFormValid()) {
    return;
  }

  const payload = {
    ...form.value,
    // Convert date strings to proper formats if needed
    chartReviewDate: form.value.chartReviewDate ? new Date(form.value.chartReviewDate).toISOString() : null,
    startDate: form.value.startDate ? new Date(form.value.startDate).toISOString() : null,
    endDate: form.value.endDate ? new Date(form.value.endDate).toISOString() : null,
    nextAppointment: form.value.nextAppointment ? new Date(form.value.nextAppointment).toISOString() : null,
    serviceDate: form.value.serviceDate ? moment(form.value.serviceDate).format("MM/DD/YYYY") : "",
  };

  emit("save-patient", payload);
  console.log("Saving patient:", payload);
}

function onReset() {
  form.value = createForm();
  emit("reset-form");
}

// Add method to handle guarantor name selection
function selectGuarantor() {
  // Add your selection logic here
  console.log("Select guarantor Clicked        >>>>>>>>>  DO SOMETHING");
}
function editGuarantor() {
  // Add your selection logic here
  console.log("EDIT guarantor clicked         >>>>>>>>>  DO SOMETHING");
}
// Load initial data (example with the provided values)
function loadSampleData() {
  form.value = {
    personID: 14526,
    firstName: "Sample",
    middleName: "M",
    lastName: "DATA",
    dateOfBirth: "1971-09-16",
    patientID: "2405061",
    memberID: "N/A",
    insuranceCarrier: "UNKNOWN",
    dob: "19710916",
    gender: "F",
    providerName: "Grizzle, Melissa",
    serviceDate: "2022-12-14",
    lastSeenByMe: "Grizzle, Melissa",
    chartReviewDate: moment("0001-01-01T00:00:00Z").isValid() ? moment("0001-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
    chartReviewBy: null,
    chartReviewNeeded: true,
    chartReviewComment: null,
    chartReviewRole: null,
    emrId: null,
    startDate: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
    nextAppointmentWith: "",
    nextAppointmentReason: "",
    nextAppointmentType: "",
    nextAppointmentComment: "",
    patientStatus: true,
    endDate: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
    appointmentLocation: null,
    isScheduled: false,
    nextAppointment: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
  };
}
function loadFromProps() {
  if (props.testPatient && typeof props.testPatient === "object") {
    form.value = {
      ...createForm(),
      ...props.testPatient,
      chartReviewDate: props.testPatient.chartReviewDate ? moment(props.testPatient.chartReviewDate).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
      startDate: props.testPatient.startDate ? moment(props.testPatient.startDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      endDate: props.testPatient.endDate ? moment(props.testPatient.endDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      nextAppointment: props.testPatient.nextAppointment ? moment(props.testPatient.nextAppointment).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
    };
  }
}

// New method to bind from store object to form
function loadFromPatientStore() {
  const currentPatient = patientStore.currentPatient;
  if (currentPatient && typeof currentPatient === "object") {
    form.value = {
      ...createForm(),
      ...currentPatient,
      // Handle date conversions
      dateOfBirth: currentPatient.dateOfBirth ? moment(currentPatient.dateOfBirth).format("YYYY-MM-DD") : "",
      serviceDate: currentPatient.serviceDate ? moment(currentPatient.serviceDate).format("YYYY-MM-DD") : "",
      chartReviewDate: currentPatient.chartReviewDate ? moment(currentPatient.chartReviewDate).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
      startDate: currentPatient.startDate ? moment(currentPatient.startDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      endDate: currentPatient.endDate ? moment(currentPatient.endDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      nextAppointment: currentPatient.nextAppointment ? moment(currentPatient.nextAppointment).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
    };
    console.log("Loaded patient from store:", currentPatient);
  } else {
    console.warn("No current patient found in store");
    alert("No current patient available in store");
  }
}

onMounted(() => {
  // console.log("onMounted() : Patient Form >>>>");
  // console.log("props : testPatient ");
  // console.log(props.testPatient);
  // loadSampleData();
  // loadFromProps();
  // loadFromPatientStore();
});
</script>

<style scoped>
.patient-form-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  height: 65vh;
  overflow: hidden;
  overflow-y: auto;
}

.form-section {
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  text-align: center;
}

.form-section h3 {
  margin-bottom: 15px;
  font-size: 1.2em;
  border-bottom: 2px solid #007bff;
  padding-bottom: 5px;
  text-align: center;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0px;
  margin-bottom: 15px;
  justify-content: stretch;
  width: 100%;
}

.form-group {
  flex: 1;
  min-width: 250px;
}

.form-group.full-width {
  flex: 100%;
}

.inline-form {
  align-items: flex-end;
  justify-content: stretch;
  width: 100%;
}

.inline-group {
  display: flex;
  align-items: center;
  gap: 0px;
  min-width: 0;
  flex: 1 1 auto;
  text-align: left;
}

.inline-group label {
  margin-bottom: 0;
  white-space: nowrap;
  min-width: 80px;
  font-size: 10px;
  text-align: right;
}

.inline-group .form-control {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
}

.form-group.checkbox-group {
  display: flex;
  align-items: center;
  min-width: auto;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  color: #495057;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  gap: 0px;
  margin-bottom: 0;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}

textarea.form-control {
  resize: vertical;
  min-height: 60px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px 0;
  border-top: 1px solid #dee2e6;
  margin-top: 20px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #545b62;
}

.btn-info {
  background-color: #17a2b8;
  color: white;
}

.btn-info:hover {
  background-color: #138496;
}

/* Bootstrap Vue inline form adjustments */
.form-row .form-group {
  margin-bottom: 0.5rem;
}

/* Compact spacing for inline forms - Remove gaps */
.inline-form .form-group {
  margin-bottom: 0.5rem;
}

/* Label styling for inline forms - Right justified, no gaps */
.form-group label.col-form-label {
  font-size: 15px !important;
  font-weight: 600;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  text-align: right !important;
  justify-content: flex-end !important;
  white-space: nowrap;
  display: flex !important;
  align-items: center !important;
}

/* Ensure all labels in form groups align right with no gaps */
.form-group .col-form-label {
  font-size: 15px !important;
  font-weight: 600;
  text-align: right !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  white-space: nowrap;
}

/* Bootstrap Vue form group label alignment - no gaps */
.form-group .col-form-label-sm {
  font-size: 15px !important;
  font-weight: 600;
  text-align: right !important;
  justify-content: flex-end !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
}

/* Override Bootstrap Vue default label alignment - remove all gaps */
.form-group .row .col-form-label,
.b-form-group .col-form-label {
  font-size: 15px !important;
  font-weight: 600;
  text-align: right !important;
  justify-content: flex-end !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  white-space: nowrap;
}

/* Additional specificity for Bootstrap Vue components - no gaps */
.b-form-group label.col-form-label {
  font-size: 15px !important;
  text-align: right !important;
  justify-content: flex-end !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
}

/* Remove Bootstrap default row gutters and spacing */
.b-form-group .row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.b-form-group .row > [class*="col"] {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* Remove gaps between labels and inputs in all sections */
.form-section .row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.form-section .row > [class*="col"] {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

/* Remove Bootstrap Vue form group internal spacing */
.b-form-group {
  margin-bottom: 0.5rem !important;
}

.b-form-group .row {
  margin: 0 !important;
}

/* Specific targeting for identification, privacy sections */
.identification-section .row,
.form-section .row {
  gap: 0 !important;
  margin: 0 !important;
}

.identification-section [class*="col"],
.form-section [class*="col"] {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

/* 10px gap between label and input columns */
.form-section .row > [class*="col"]:first-child {
  padding-right: 10px !important;
  padding-left: 0 !important;
}

.form-section .row > [class*="col"]:not(:first-child) {
  padding-left: 0 !important;
  padding-right: 5px !important;
}

/* Label styling for inline Privacy section */
.form-section label {
  font-size: 13px;
  font-weight: 600;
  color: #dcf1de !important; /* Match b-form-group label color */
  white-space: nowrap;
  padding: 0 !important;
  margin: 0 !important;
}

/* Add/override for city/state row alignment */
.form-section .b-form-group .row.no-gutters {
  margin-left: 0 !important;
  margin-right: 0 !important;
  gap: 0 !important;
}
.form-section .b-form-group .row.no-gutters > [class*="col"] {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* Reduce gap between city and state columns */
.form-section .b-form-group .row.no-gutters > .pr-1 {
  padding-right: 4px !important;
}
.form-section .b-form-group .row.no-gutters > .pl-1 {
  padding-left: 4px !important;
}
</style>
